import { lazy } from 'react';

const GuardianCreationTypeModal = lazy(() =>
  import('./components/GuardianCreationTypeModal'),
);

export default {
  GUARDIAN_CREATION_TYPE: GuardianCreationTypeModal,
};
